import { Skeleton } from '@mui/material'
import { QRCodeSVG } from 'qrcode.react'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useCreate2faTotpUrl } from 'src/hooks'
import { ETranslationNs } from 'src/types'

import { useStyles } from '../../styles'

export const QRCodeStep = () => {
  const classes = useStyles()
  const { data: totpUri } = useCreate2faTotpUrl()

  return (
    <div className={classes.qrCodeSection}>
      <div>
        <p className={classes.stepText}>
          <HelperWrapper t="2fa-step-text" ns={ETranslationNs.UserProfile} /> 2
        </p>
        <h3 className={classes.sectionTitle}>
          <HelperWrapper t="2fa-totp-setup-2-title" ns={ETranslationNs.UserProfile} />
        </h3>
        <p className={classes.sectionText}>
          <HelperWrapper t="2fa-totp-setup-2-text" ns={ETranslationNs.UserProfile} />
        </p>
      </div>
      <div className={classes.qrCodeWrapper}>
        {totpUri ? (
          <QRCodeSVG value={totpUri} />
        ) : (
          <Skeleton width={128} height={128} variant="rounded" />
        )}
      </div>
    </div>
  )
}
